import React from 'react';

/**
 * Renders a concise human-readable summary of section logic.
 * New shape: { SECTION_KEY:{ root:{ type:'group', op:'AND'|'OR', children:[cmpId,...] } } }
 * Backward compatibility: if section has no root, treat the section object as root group directly.
 */
export default function SectionsSummary({ sections }) {
  return (
    <div className="space-y-2 text-[10px] font-mono">
      {Object.entries(sections).map(([key, sec]) => {
        const root = sec?.root ? sec.root : sec;
        const expr = (root.children||[]).length === 0
          ? '(empty)'
          : root.children.map(id => `cmp:${id}`).join(` ${root.op} `);
        return (
          <div key={key} className="flex items-start gap-2">
            <span className="min-w-[90px] font-semibold text-textSecondary">{key}</span>
            <span className="flex-1 px-2 py-1 rounded bg-muted/30 border border-borderDefault">{expr}</span>
          </div>
        );
      })}
    </div>
  );
}
